import { render, staticRenderFns } from "./ShowcaseFaq.vue?vue&type=template&id=582785d0&scoped=true&xmlns%3Ath=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ShowcaseFaq.vue?vue&type=script&lang=js"
export * from "./ShowcaseFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582785d0",
  null
  
)

export default component.exports